export default "__VITE_ASSET__8bb5eb6b__"